// @ts-nocheck
import { searchInputStyles, SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(searchInputStyles, {
    input: mergeProps(searchInputStyles.input, {
        cssOverrides: {
            formField: css`
                max-width: ${pxToRem(735)};
            `,
        },
    }),
} as SearchInputStyles);
